import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';

import FileAccess from './Access';
import FileExtension from './Extension';
import FileResolution from './Resolution';
import FileSize from './Size';
import FileVersion from './Version';

const FileDetails = ({
  className,
  file,
  showAccess,
  share,
}) => (
  <div className={classnames('file-details', className)}>
    <div>
      {showAccess && (
        <FileAccess
          file={file}
        />
      )}
      <FileResolution
        file={file}
      />
      <FileExtension
        file={file}
      />
      <FileSize
        file={file}
      />
      {!(share && !share.allow_versions) && (
        <FileVersion
          file={file}
        />
      )}
    </div>
  </div>
);

const mapStateToProps = state => ({
  share: state.Shares.share,
});

FileDetails.propTypes = {
  className: PropTypes.string,
  file: PropTypes.object.isRequired,
  showAccess: PropTypes.bool.isRequired,
  share: PropTypes.object,
};

FileDetails.defaultProps = {
  className: '',
  share: null,
};

export default connect(mapStateToProps)(FileDetails);
